import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import StickyActions from "./components/StickyActions";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Certificates from "./pages/Certificates";
import Gallery from "./pages/Gallery";
import Catalogs from "./pages/Catalogs";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";
import GlobalReach from "./pages/GlobalReach";
import Updates from "./pages/Updates";
import UpdateDetail from "./pages/UpdateDetail";
import Insights from "./pages/Insights";
import InsightsPost from "./pages/InsightsPost";
import RiceExportersPakistan from "./pages/RiceExportersPakistan";
import IntroPreview from "./pages/IntroPreview";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AuthCallback from "./pages/admin/AuthCallback";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash && !hash.includes("session_id=")) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
      return () => clearTimeout(t);
    }
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

const AppShell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <main className={isAdmin ? "" : "pb-16 md:pb-0"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/intro-preview" element={<IntroPreview />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/rice-exporters-pakistan" element={<RiceExportersPakistan />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightsPost />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/catalogs" element={<Catalogs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/global-reach" element={<GlobalReach />} />
          <Route path="/updates" element={<Updates />} />
          <Route path="/updates/:slug" element={<UpdateDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyActions />}
      <Toaster />
    </>
  );
};

const AppRouter = () => {
  const location = useLocation();
  // Handle OAuth return: process session_id BEFORE anything else
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return <AppShell />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
